export const dof = [
    {
        "tramite_loc" : "Diario Oficial de la Federación (26/Abril/2025)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se actualiza el Compendio Nacional de Insumos para la Salud versión 2025.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/26042025-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (11/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se actualiza el Compendio Nacional de Insumos para la Salud versión 2025, publicado el 26 de Abril de 2025.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/11062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (03/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se actualiza el Compendio Nacional de Insumos para la Salud versión 2025, publicado el 26 de Abril de 2025.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/03072026-VES.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (19/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se actualiza el Compendio Nacional de Insumos para la Salud versión 2025, publicado el 26 de Abril de 2025.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/19082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (25/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se actualiza el Compendio Nacional de Insumos para la Salud versión 2025, publicado el 26 de Abril de 2025.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/25092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (04/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se actualizan los medios de presentación de los trámites COFEPRIS-04-010 “Solicitud de modificación o enmienda a la autorización de protocolo de investigación”",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/04052026-VES.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (11/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se amplía la Jornada de Medicina Preventiva en el Transporte para la Unidad Médica de Pachuca del Centro SICT Hidalgo. ",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/11062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (28/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se deja insubsistente el numeral 12. Eritrosina y sus lacas, Rojo Alimentos 14. Rojo 3 FD&C. No. CI: 45430, SIN: 127 del Anexo III Colorantes con IDA establecida del Acuerdo por el que se determinan los aditivos y coadyuvantes en alimentos, bebidas y suplementos alimenticios, su uso y disposiciones sanitarias, publicado el 16 de julio de 2012, y modificado el 05 de septiembre de 2013 y 16 de mayo de 2016.os, bebidas y suplementos alimenticios, su uso y disposiciones sanitarias, publicado el 16 de julio de 2012, y modificado el 05 de septiembre de 2013.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/28052026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (21/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se determinan los aditivos y coadyuvantes en alimentos, bebidas y suplementos alimenticios, su uso y disposiciones sanitarias.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/21082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (27/Abril/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se emite el Protocolo interinstitucional para la transferencia  de personas que viven con VIH en las instituciones públicas del Sistema Nacional de Salud.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/27042026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (28/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se emiten los Lineamientos de Operación del Programa \"Consultorios del Servicio Universal de Salud\" para el ejercicio fiscal 2026.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/28092026-VES.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (02/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se emiten los Lineamientos Generales para la aplicación de la vía regulatoria abreviada para el otorgamiento de los registros sanitarios de medicamentos en los que se reconocen como equivalentes los requisitos solicitados, pruebas y procedimientos de evaluación emitidos por la Agencia Nacional de Vigilancia Sanitaria de la República Federativa de Brasil.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/02092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (10/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se emiten los Lineamientos para la obtención del Folio de Registro en el Plan Maestro Nacional de Infraestructura en Salud y Equipamiento Médico de Alta Tecnología.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/10082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (02/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se emiten los Lineamientos para las Solicitudes de Autorización de Tercero, sus modificaciones y prórroga de su vigencia.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/02092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (01/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se establece el Comité Nacional de Partería.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/01052026-VES.pdf",
            },
            {
                "tramite_item_nombre" : "Acuerdo por el que se modifican, adicionan y derogan diversas disposiciones del Acuerdo por el que se establece el Comité Nacional de Partería publicado el 1 de mayo de 2026. (18/Junio/2026)",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18062026-MAT.pdf",
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (03/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se establece la meta nacional de eliminación y prevención de restablecimiento de la transmisión del paludismo autóctono y los criterios a cumplir por las entidades federativas para su certificación.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/03082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (24/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se establece la obligatoriedad de la implementación de los Protocolos Nacionales de Atención Médica relacionados con el Síndrome cardio-renal-metabólico en las instituciones públicas que prestan servicios de salud.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/24082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (27/Abril/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se establecen acciones de simplificación para trámites que se realizan ante el Centro Nacional de la Transfusión Sanguínea.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/27042026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (04/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se establecen acciones de simplificación para trámites que se realizan ante la Comisión Federal para la Protección contra Riesgos Sanitarios.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/04052026-VES.pdf"
            }
         ]
    }, 
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Febrero/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se implementa el sistema de Monitoreo al Cumplimiento de Abasto de Insumos para la Salud.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09022026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se modifica el diverso por el que se da a conocer a los gobiernos de las entidades federativas la distribución y calendarización para la ministración, durante el ejercicio fiscal de 2026, de los recursos correspondientes a los ramos generales 28 Participaciones a Entidades Federativas y Municipios y 33 Aportaciones Federales para Entidades Federativas y Municipios, publicado en el Diario Oficial de la Federación el 12 de diciembre de 2025, y sus modificaciones publicadas en ese órgano de difusión oficial del 6 de febrero y 8 de abril de 2026, en materia del Fondo de Aportaciones para los Servicios de Salud.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (16/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se modifica el diverso por el que se da a conocer a los gobiernos de las entidades federativas la distribución y calendarización para la ministración, durante el ejercicio fiscal de 2026, de los recursos correspondientes a los Ramos Generales 28 Participaciones a Entidades Federativas y Municipios y 33 Aportaciones Federales para Entidades Federativas y Municipios, publicado el 12 de diciembre de 2025, y sus modificaciones publicadas el 6 de febrero, 8 de abril, y 9 de julio de 2026, en materia del Fondo de Aportaciones para los Servicios de Salud.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/16102026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (29/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se modifica el diverso por el que se instruye la Secretaría de Salud, a Laboratorios de Biológicos y Reactivos de México, S.A. de C.V.,al Instituto Mexicano del Seguro Social para el Bienestar llevar a cabo las acciones que se indican.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/29052026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (07/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se reforma el Marco Conceptual de Contabilidad Gubernamental.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_sep_07_ord0_36.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (07/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Acuerdo por el que se reforma y adiciona el Manual de Contabilidad Gubernamental.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_sep_07_ord0_36.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (04/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso de consulta pública del Proyecto de Norma Oficial Mexicana PROY-NOM-016-SSA-2026, Para la vigilancia, prevención, control, manejo y tratamiento de cólera.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/04062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (01/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso de consulta pública del Proyecto de Norma Oficial Mexicana PROY-NOM-027-SSA-2026, Para la prevención, control y eliminación de la lepra.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/01102026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (04/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso de consulta pública del Proyecto de Norma Oficial Mexicana PROY-NOM-032-SSA-2026, Para la vigilancia, promoción, prevención, control, manejo, tratamiento y control de las enfermedades  transmitidas por vectores e intoxicación por artrópodos venenosos y serpientes de importancia médica toxicológica.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/04062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (23/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso mediante el cual se da a conocer el hipervínculo electrónico que redirige al Tabulador de Cuotas de Recuperación 2026 del Instituto Nacional de Medicina Genómica.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/23062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (17/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso mediante el cual se da a conocer la liga electrónica que redirige a los Lineamientos para los procedimientos de contratación consolidada y servicio integral de recepción, almacenamiento y distribución de medicamentos, material de curación y demás insumos para la salud",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/17082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (21/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso por el que se dan a conocer las ligas electrónicas para consulta de los Lineamientos que se indican.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/21092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (21/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso por el que se dan a conocer las ligas electrónicas para consulta de los Protocolos Nacionales de Atención Médica que se indican.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/21082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (21/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso por el que se emite el Manual del Modelo de Certificación y Estandarización de Buenas Prácticas en Atención de Servicios de Salud para Unidades de Diagnóstico y Tratamiento.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/21082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (15/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso por el que se hace del conocimiento del público en general la incorporación de diversas autoridades a los Modelos de Interconexión Digital del Poder Judicial de la Federación.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/15072026-MAT.pdf"
            }
         ]
    }, 
    {
        "tramite_loc" : "Diario Oficial de la Federación (03/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso por el que se hace del conocimiento del público en general la incorporación de diversas autoridades a los Modelos de Interconexión Digital del Poder Judicial de la Federación.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/03082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (26/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso por el que se hace del conocimiento del público en general la incorporación de diversas autoridades a los Modelos de Interconexión Digital del Poder Judicial de la Federación.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/26082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (17/Febrero/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso por el que se modifica el diverso por el que se da a conocer por parte de la Dirección General de Profesiones el estándar oficial de la Cédula profesional, publicado el 10 de Abril de 2018.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/17022026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (20/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Aviso referente a la venta de la Farmacopea de los Estados Unidos Mexicanos 14.0, en sus versiones electrónica e impresa.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/20082026-MAT.pdf"
            }
         ]
    },   
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (25/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular 003 Cancelación del registro en el padrón de proveedores de la administración pública del Gobierno del Estado de Hidalgo, por un lapso de 05 cinco años, y la cancelación del registro en el padrón de contratistas de la administración pública del Gobierno del Estado de Hidalgo, por un lapso de 06 seis años.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_may_25_ord0_21.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (15/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular 004 cancelación del registro en el padrón de proveedores de la administración pública del Gobierno del Estado de Hidalgo, por un lapso de 05 cinco años, y la cancelación del registro en el padrón de contratistas de la administración pública del Gobierno del Estado de Hidalgo, por un lapso de 06 seis años.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jun_15_ord0_24.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (15/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular 005 se informa a los proveedores inscritos en el Padrón de Proveedores del Estado de Hidalgo que aquellos proveedores que no hayan efectuado el canje de su registro con vigencia de dos años, dentro del plazo establecido cuyo vencimiento fue el 15 de junio de 2026, dejan de formar parte de dicho padrón.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jun_15_ord0_24.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (21/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular 006, padrón de proveedores de la Administración Pública del Estado de Hidalgo y el padrón de contratistas de obras públicas y servicios relacionados con las mismas a través de una única plataforma electrónica institucional.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_sep_21_ord0_38.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (21/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular 007, cancelación de los registros en el padrón de proveedores de la Administración Pública del Gobierno del Estado de Hidalgo.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_sep_21_ord0_38.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (23/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por el que se comunica a las dependencias y entidades de la Administración Pública Federal y a las entidades federativas el cumplimiento dado a la sentencia definitiva de veintitrés de septiembre de dos mil veinticuatro, dictada en el juicio de nulidad 25835/23-17-12-1, promovido por el C. Ángel Pérez Dorante, en representación legal de K.P. Asociados, S.A. de C.V., en la cual la Décimo Segunda Sala Regional en la Ciudad de México del Tribunal Federal de Justicia Administrativa, declaró la nulidad de la resolución contenida en el oficio No. OIC/00/637/22453/2023 de veintiocho de marzo de dos mil veintitrés, emitida dentro del procedimiento administrativo de sanción a licitantes, proveedores y contratistas SAN-002/2023.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/23062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (07/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por el que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas, a la Fiscalía General de la República, a las empresas públicas del Estado, municipios y demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas y celebrar contratos con la empresa ATV de Sahuayo, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/07072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (04/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por el que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas, a los municipios, los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas y/o celebrar contratos con la empresa Brigalag, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/04062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (17/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal el cumplimiento dado a la sentencia definitiva de veinticuatro de marzo de dos mil veintiséis, dictada en el juicio de nulidad 715/25-21-01-4-OT, promovido por el C. Eder Vieyra Sánchez, en la cual la sala Regional en Michoacán del Tribunal Federal de Justicia Administrativa, declaró la nulidad de la resolución contenida en el oficio No. OICE/00/637/19606/2024 de dieciséis de diciembre de dos mil veinticuatro, emitida dentro del procedimiento administrativo de sanción a licitantes, proveedores y contratistas PA-032/2024.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/17082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (05/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal y a las entidades federativas el cumplimiento dado a la sentencia definitiva de seis de abril de dos mil veintiséis, dictada por la Primera Sala Regional en la Ciudad de México del Tribunal Federalde Justicia Administrativa, en el juicio de nulidad 25287/22-17-01-4, promovido por la moral INT-PER, S.A. de C.V., mediante la cual se declaró la nulidad de la Resolución de treinta de agosto de dos mil veintidós, emitida dentro del procedimiento administrativo de responsabilidades PAR-0602/2022.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/05102026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (16/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal y a las entidades federativas el cumplimiento dado a la sentencia definitiva de veintitrés de marzo de dos mil veintiséis, dictada por la Sala Regional en Michoacán del Tribunal Federal de Justicia Administrativa, en el juicio de nulidad 937/25-21-01-9-OT, promovido por la C. María Guadalupe Banderas Chávez mediante la cual se declaró la nulidad de la resolución contenida en el oficio OICE/00/637/19391/2024 de once de diciembre de dos mil veinticuatro, emitida dentro del procedimiento administrativo de sanción a licitantes, proveedores y contratistas PA-031/2024.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/16072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a la Fiscalía General de la República, a las empresas públicas del Estado, a las demarcaciones territoriales de la Ciudad de México, así como a las entidades federativas y sus municipios, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Garza Gas, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a la Fiscalía General de la República, a las empresas públicas del Estado, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México que deberán abstenerse de participar en procedimientos de contratación o celebrar contratos con la persona moral Servicios Especiales de Gas LP, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (31/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Públca Federal, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la persona moral Fedang de México S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/31082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (20/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a la Fiscalía General de la República, a las entidades federativas, a los municipios y a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Transmareli, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/20082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (15/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a la Fiscalía General de la República, a las entidades federativas, municipios y demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Ingeniería y Desarrollo de Obras Suma, S.A. de C.V. y la persona física que la representó el Ciudadano Omar Suárez Márquez, incluso cuando este último pretenda representar a empresas diversas a la sancionada.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/15062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (01/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a la Fiscalía General de la República, a las entidades federativas, municipios y demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Metales y Cobres de Ecatepec, S.A. de C.V. y la persona física que la representó el ciudadano Arturo Rivas Escobar, incluso cuando este último pretenda representar a empresas diversas a la sancionada.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/01102026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (16/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a la Fiscalía General de la República, a las entidades federativas, municipios y demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Comercializadora Jass de Compresores, S.A. de C.V. y la persona física que la representó el ciudadano Juan Antonio Soria Yáñez, incluso cuando este último pretenda representar a empresas diversas a la sancionada.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/16072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (03/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a la Fiscalía General de la República, así como a las entidades federativas y sus municipios, que deberán abstenerse de aceptar propuestas o celebrar contratos con la persona física Roy González Padilla.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/03092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (03/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la administración pública federal, a las empresas productivas del estado, así como a las entidades federativas, municipios y alcaldías de la Ciudad de México que la AGENCIA DE ARTE Y PUBLICIDAD PAZ, S.A. DE C.V., fue inhabilitada por el período de tres meses.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_sep_03_alc2_35.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (03/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la administración pública federal, a las empresas productivas del estado, así como a las entidades federativas, municipios y alcaldías de la Ciudad de México que la particular presunta responsable SILVIA HERNÁNDEZ ROMERO, fue inhabilitada por el período de tres meses.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_sep_03_alc2_35.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (16/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas productivas del Estado, así como a las entidades federativas, municipios y alcaldías de la Ciudad de México, que la empresa RMCH Construcciones S.A. de C.V. y el C. José Ricardo Montiel Chavarría fueron inhabilitadas por el periodo de tres meses. ",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/16062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (10/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas productivas del Estado, así como a las entidades federativas, municipios y alcaldías de la Ciudad de México, que la particular responsable Veligheid del Centro S.A. de C.V. se encuentra en una inhabilitación temporal por el periodo de tres meses para participar en adquisiciones, arrendamientos, Servicios u obras públicas.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jun_10_alc1_23.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (08/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la administración pública federal, a las empresas productivas del estado, así como a las entidades federativas, municipios y alcaldías de la Ciudad de México, que la particular responsable PERLA GUADALUPE ÑÚLEZ SOLÍS, se encuentra en una inhabilitación temporal por el período de tres meses para participar en adquisiciones, arrendamientos, servicios u obras públicas.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_oct_08_alc2_40.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (10/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas públicas del Estado, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Abastecedora y Distribuidora del Sureste García Hnos, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/10072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (07/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas públicas del Estado, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Impulsora Cordobesa de Alimentos y Servicios, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/07072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (22/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas públicas del Estado, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Maquinaria e Ingeniería, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jun_22_circular.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas públicas del Estado, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa SOS Sistemas Opcionales en Salud, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (06/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas públicas del Estado, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, que el Juzgado Sexto de Distrito en Materia Administrativa en la Ciudad de México, en el juicio de amparo número 1518/2026-VII, interpuesto por la representación legal de la empresa Proteín, Sociedad Anónima de Capital Variable, en donde se controvierte el Acuerdo del veinticuatro de julio de dos mil veintiséis, emitido dentro del recurso de revisión RR-17/2026, promovido en contra de la resolución administrativa de fecha ocho de julio de dos mil veintiséis recaída al expediente administrativo número PISI-A-NC-DS-0001/2026.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/06102026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (21/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas públicas del Estado, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Alta Especialidad de Medicina y Capacitación, S.C.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/21072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (21/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas públicas del Estado, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Protein, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/21072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (11/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas públicas del Estado, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la persona física Eliana Díaz Magaña",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/11082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (19/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las empresas públicas del Estado, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, el cumplimiento a la sentencia interlocutoria del primero de julio de dos mil veintiséis, emitida por la Sexta Sala Regional en la Ciudad de México del Tribunal Federal de Justicia Administrativa, en el juicio de nulidad 10988/26-17-06-3, interpuesto por la representación legal de la empresa Hima Promotions, S.A. de C.V., en donde se controvierte la resolución del primero de abril de dos mil veintiséis, emitida dentro del expediente administrativo número PISI-A-NC-DS-0001/2025.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/19082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas y sus municipios, a los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Links & Masters Corporation, S.A.P.I. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (24/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas y sus municipios, a los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas y/o celebrar contratos con la persona moral denominada Limpieza Géminis, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/24082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (02/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas y sus municipios, a los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas y/o celebrar contratos con la empresa IFASER, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/02092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (03/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas y sus municipios, los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Profesionales en Vigilancia y Seguridad Privada, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/03082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (17/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas y sus municipios, los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Comercializadora Hermanos del Valle, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/17072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (28/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas, a la Fiscalía General de la República, a las empresas públicas del Estado, a los municipios y a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas y celebrar contratos con la empresa ATV de Sahuayo, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/28082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas, a los municipios, a las demarcaciones territoriales de la Ciudad de México, así como a los entes públicos de unas y otros, que deberán abstenerse de aceptar propuestas y/o celebrar contratos con la empresa Simec Servicios de Ingeniería, Mecánica, Eléctrica y Civil, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (20/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas, a los municipios, los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas y/o celebrar contratos con la empresa Bernabeu México, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/20072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas, municipios, los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas y/o celebrar contratos con la empresa Construcciones Zarate Prados, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09102026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas, municipios, los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas y/o celebrar contratos con la empresa Ingeniería y Construcción CT, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (16/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas, municipios, los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas y/o celebrar contratos con la empresa AM Cenit, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/16102026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (05/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, así como a las entidades federativas que deberán abstenerse de aceptar propuestas o celebrar contratos con la moral Bioabast, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/05062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (04/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, así como a las entidades federativas, el acuerdo de fecha veinte de mayo de dos mil veintiséis, por el que se da cumplimiento a la sentencia definitiva de diecinueve de noviembre de dos mil veinticinco, dictada en el juicio de nulidad 12276/23-17-05-7, promovido por el C. Erick Moctezuma Ríos Ángeles, en representación legal de la empresa MYK Solutions And Services de México, S.A. DE C.V., por medio de la cual la Quinta Sala Regional Metropolitana del Tribunal Federal de Justicia Administrativa, declaró la nulidad de la resolución contenida en el oficio OIC/00/637/24109/2023, de fecha veintiséis de abril de dos mil veintitrés, emitida dentro del procedimiento administrativo de sanción a licitantes, proveedores y contratistas PA-004/2023.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/04062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (05/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, así como a las entidades federativas, el cumplimiento dado a la sentencia definitiva de fecha once de noviembre de dos mil veinticuatro, dictada en el juicio de nulidad 7987/22-17-03-3, promovido por la empresa Bioabast, S.A. de C.V., por medio de la cual la Tercera Sala Regional Metropolitana del Tribunal Federal de Justicia Administrativa, declaró la nulidad de la resolución contenida dictada el veintidós de febrero de dos mil veintidós, emitida dentro del procedimiento administrativo de sanción a licitantes, SAN-019/2021.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/05062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (26/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, empresas públicas del Estado, a la Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, el cumplimiento a la suspensión provisional, decretada por la Sexta Sala Regional en la Ciudad de México del Tribunal Federal de Justicia Administrativa, en el juicio de nulidad 10988/26-17-06-3, interpuesto por la representación legal de la empresa Hima Promotions, S.A. de C.V., en donde se controvierte la resolución del primero de abril de dos mil veintiséis, emitida dentro del expediente administrativo número PISI-A-NC-DS-0001/2025.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/26062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (21/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, empresas públicas del Estado, Fiscalía General de la República, a las entidades federativas y sus municipios, así como a las demarcaciones territoriales de la Ciudad de México, el cumplimiento dado a la sentencia interlocutoria de fecha 01 de julio de 2026, dictada dentro de la instancia de queja del incidente de medidas cautelares del juicio de nulidad número 24387/24-17-07-7, promovido por la moral IQ Orgullo de Pertenencia, S.A. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/21072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (06/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, empresas públicas del Estado, Fiscalía General de la República, así como a las entidades federativas, que deberán abstenerse de aceptar propuestas o celebrar contratos con la persona física Eréndira López Carreón.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/06102026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, empresas públicas del Estado, Fiscalía General de la República, entidades federativas y sus municipios, así como demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con el licitante Ezequiel Becerril Barrera.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09102026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (15/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, empresas públicas del Estado, Fiscalía General de la República, entidades federativas y sus municipios, así como las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Galmar Proyectos Integrales, S. de R.L. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/15072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (28/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, empresas públicas del Estado, Fiscalía General de la República, entidades federativas y sus municipios, así como las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Galmar Proyectos Integrales, S. de R.L. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/28092026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (26/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, empresas públicas del Estado, Fiscalía General de la República, entidades federativas, y sus municipios, así como demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Galmar Proyectos Integrales, S. de R.L. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/26082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (21/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, Fiscalía General de la República, entidades federativas, municipios y demarcaciones territoriales de la Ciudad de México, que el Juzgado Octavo de Distrito en Materia Administrativa en la Ciudad de México, dentro del incidente de suspensión deducido del juicio de amparo indirecto número 1591/2026, promovido por la empresa Intman, S.A. de C.V., por conducto de su representante legal, el ciudadano John Lorenzo Días Salas, mediante acuerdo de treinta y uno de julio de dos mil veintiséis, concedió la suspensión provisional del acto reclamado, para el efecto de que el Titular del Área de Responsabilidades del Órgano Interno de Control en la Secretaría de la Defensa Nacional, cancele el registro de la quejosa en el Padrón de Proveedores y Contratistas Sancionados, hasta en tanto se resuelve de fondo el referido juicio de amparo.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/21082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (16/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, Fiscalía General de la República, entidades federativas, municipios y demarcaciones territoriales de la Ciudad de México, que el Juzgado Octavo de Distrito en Materia Administrativa en la Ciudad de México, determinó dentro del juicio de amparo indirecto número 299/2026, promovido por la empresa Intman, S.A. de C.V., por conducto de su representante legal, el ciudadano John Lorenzo Días Salas, mediante acuerdo de veintitrés de abril de dos mil veintiséis, el sobreseimiento del juicio antes señalado y advirtió que al no acreditarse el pago de la sanción impuesta subsiste la inhabilitación determinada en el procedimiento administrativo de sanción a proveedores número 005/PAS/2024.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/16072026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (01/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular por la que se comunica a las dependencias y entidades de la Administración Pública Federal, Fiscalía General de la República, entidades federativas, municipios y demarcaciones territoriales de la Ciudad de México, que la Segunda Sala Regional en la Ciudad de México del Tribunal Federal de Justicia Administrativa, dentro del juicio contencioso administrativo número 22553/24-17-02-5, promovido por la empresa Global Services Performance Harr, S.A. de C.V., por conducto de su representante legal, la ciudadana Jeanette Jessamyn Mejía Avendaño, mediante sentencia de diez de diciembre de dos mil veinticinco, en cumplimiento a la ejecutoria de diecinueve de noviembre de dos mil veinticinco emitida por el Vigésimo Cuarto Tribunal Colegiado en Materia Administrativa del Primer Circuito en el juicio de amparo D.A 403/2025, determinó la nulidad de la resolución número AR07/M-VIIF/3514 de siete de agosto de dos mil veinticuatro, dictada en el procedimiento administrativo de sanción a proveedores y licitantes número 030/PAS/2023.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/01102026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (19/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular SABG/420/OICSICT/AR/473/2026 por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas, municipios, a los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Teleconstrucciones Marver, S. de R.L. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/19082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (19/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular SABG/420/OICSICT/AR/476/2026 por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas y sus municipios, a los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Teleconstrucciones Marver, S. de R.L. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/19082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (19/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular SABG/420/OICSICT/AR/479/2026 por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas y sus municipios, a los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Teleconstrucciones Marver, S. de R.L. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/19082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (19/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Circular SABG/420/OICSICT/AR/482/2026 por la que se comunica a las dependencias y entidades de la Administración Pública Federal, a las entidades federativas y sus municipios, a los entes públicos de unas y otros, así como a las demarcaciones territoriales de la Ciudad de México, que deberán abstenerse de aceptar propuestas o celebrar contratos con la empresa Teleconstrucciones Marver, S. de R.L. de C.V.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/19082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (27/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Consejo Nacional de Armonización Contable.- Acuerdo por el que se reforma y adiciona la Clasificación Programática (tipología general).",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_27_ord0_30.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (08/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 367 – LXVI por el que se reforman y adicionan diversas disposiciones de la Ley de Salud Mental y Prevención del Suicidio para el Estado de Hidalgo, en materia de no discriminación a personas de la diversidad sexogenérica.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_08_alc1_27.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (08/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 397 – LXVI por el que se reforma el tercer párrafo del artículo 10 de la Ley de Educación del Estado Hidalgo, en materia de fortalecimiento a la atención de la salud escolar.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_08_alc1_27.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (08/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 400 – LXVI por el que se reforman y adicionan diversas disposiciones de la Ley de Acceso de las Mujeres a una Vida Libre de Violencia para el Estado de Hidalgo, en materia de indicadores de medición y mecanismos de evaluación.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_08_alc1_27.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (08/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 585 – LXVI por el que se reforma la fracción I del artículo 21 y se adiciona una fracción XII bis al artículo 4 de la Ley de los Derechos de las Personas Adultas Mayores del Estado de Hidalgo, en materia de atención médica integral.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_08_alc1_27.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (08/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 594 – LXVI por el que se reforman y adicionan diversas disposiciones de la Ley de Responsabilidades Administrativas del Estado de Hidalgo, en materia de combate a la corrupción, transparencia y rendición de cuentas, en materia de armonización en combate a la corrupción, transparencia y rendición de cuentas.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_08_alc1_27.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (08/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 603 – LXVI que adiciona la fracción VI bis del artículo 48 y el título décimo sexto, denominado \"del uso de la fuerza\", su capítulo único, denominado \"disposiciones generales\" y los artículos 203 y 204 de la Ley de Seguridad Pública para el Estado de Hidalgo.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_08_alc1_27.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (28/Abril/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 612 – LXVI por el que se adiciona un segundo párrafo al artículo 8 de la Constitución Política del Estado de Hidalgo, en materia de protección a la salud.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_abr_28_alc0_17.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (28/Abril/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 613 - LXVI por el que se adicionan diversas disposiciones a la Constitución Política del Estado de Hidalgo, en materia del derecho al cuidado.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_abr_28_alc0_17.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (28/Abril/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 618 – LXVI por el que se reforma la fracción XXX del apartado a del artículo 3 de la Ley de Salud para el Estado de Hidalgo en materia de prevención del cáncer.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_abr_28_alc0_17.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (07/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 624-LXVI. Por el que se adiciona un párrafo tercero al artículo 7 de la Constitución Política del Estado de Hidalgo, en materia de erradicación de la brecha salarial por razones de género.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/Decreto 624-LXVI.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (11/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 645 – LXVI Por el que se reforman las fracciones V, VII y VIII y se adiciona una fracción IX al Artículo 14 de la Ley de entrega recepción de los recursos públicos para el Estado de Hidalgo, en materia de información y documentación que se acompaña al acta de Entrega Recepción.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jun_11_alc2_23.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (17/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 649 – LXVI por el que se reforman y adicionan diversas disposiciones al artículo 40 de la Ley de los Trabajadores al Servicio de los Gobiernos Estatal y Municipales, así como de los Organismos Descentralizados del Estado de Hidalgo, en materia de acoso laboral.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jun_17_alc1_24.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (26/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 651 – LXVI por el que se reforman y adicionan diversas disposiciones de la Ley de Asistencia Social para el Estado de Hidalgo, en materia de derechos y obligaciones de los sujetos de asistencia social.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jun_26_alc3_25.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (26/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 653 – LXVI por el que se reforman y adicionan diversas disposiciones de los Derechos de las Personas Adultas Mayores del Estado de Hidalgo, en materia de envejecimiento activo.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jun_26_alc3_25.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (06/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 658 – LXVI por el que se reforma el párrafo segundo de la fracción XI del artículo 5 de la Ley de Acceso de las Mujeres a una Vida Libre de Violencia para el Estado de Hidalgo, en materia de violencia digital.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_06_ord0_27.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (06/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 659 – LXVI por el que se adicionan diversas disposiciones a la Ley de Salud para el Estado de Hidalgo, en materia de procedimientos médico estéticos y cirugía plástica en adolescentes.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_06_ord0_27.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (27/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 663 – LXVI por el que se adiciona un segundo párrafo al artículo 10 de la Ley de Acceso de las Mujeres a una Vida Libre de Violencia para el Estado de Hidalgo, en materia de violencia laboral horizontal y ascendente.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_27_ord0_30.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (27/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 670 – LXVI por el que se reforman y adicionan diversas disposiciones del artículo 6 de la Ley de Migrantes Hidalguenses y en contexto de movilidad, en materia de atención integral a mujeres migrantes con perspectiva de género.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_27_ord0_30.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (27/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 672 – LXVI por el cual se reforma el artículo 2 de la Ley de Cultura Física, Deporte y Recreación para el Estado de Hidalgo, en materia de promoción de la activación física regular.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_27_ord0_30.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (06/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 673 – LXVI por el que se reforman diversas disposiciones de la Ley para Prevenir, Atender, Sancionar y Eliminar la Discriminación en el Estado de Hidalgo, en materia de orientación sexual, identidad y expresión de género.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_06_alc2_31.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (06/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 675 – LXVI por el que se reforman las fracciones XI y XVIII del artículo 4 de la Ley de Acceso de las Mujeres a una Vida Libre de Violencia para el Estado de Hidalgo, en materia de perspectiva de género y violencia contra las mujeres.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_06_alc2_31.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (06/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 679 – LXVI que reforma, adiciona y deroga diversas disposiciones del Código Penal para el Estado de Hidalgo.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_06_alc2_31.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (06/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 683 – LXVI por el que reforma la fracción III, del artículo 10 de la Ley de Salud Mental y Prevención del Suicidio para el Estado de Hidalgo.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_06_alc2_31.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (06/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 684 – LXVI por el que se reforma el párrafo sexto del artículo 10 de la Ley de Educación del Estado de Hidalgo, en materia de educación para la salud y prevención del sobrepeso y la obesidad en el entorno escolar.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_06_alc2_31.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (17/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 686 – LXVI por el que se reforma la fracción X del artículo 11 TER de la Ley de Salud para el Estado de Hidalgo, en materia de enfoque de cuidados.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_17_alc0_33.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (17/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 690 – LXVI por el que se adiciona un artículo 8 Bis a la Ley de Víctimas para el Estado de Hidalgo, en materia de primer contacto con mujeres víctimas.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_17_alc0_33.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (28/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 696 – LXVI por el que se reforman y adicionan diversas disposiciones de la Ley de los Derechos de las Personas Adultas Mayores del Estado de Hidalgo y de la Ley de Educación del Estado de Hidalgo, en materia de alfabetización digital.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_28_alc5_34.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (28/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 706 – LXVI por el que se reforman y adicionan diversas disposiciones de la Ley de los Derechos de las Personas Adultas Mayores del Estado de Hidalgo, en materia de protección integral, cuidados, asistencia y seguridad jurídica.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_28_alc5_34.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (28/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 712 – LXVI por el que se adiciona la fracción VII bis al artículo 5 de la Ley de Acceso de las Mujeres a una Vida Libre de Violencia para el Estado de Hidalgo, en materia de embarazo infantil.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_28_alc5_34.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (18/Septiembre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 713 – LXVI por el que se actualiza la denominación de la Ley de Acceso de las Mujeres a una Vida Libre de Violencia para el Estado de Hidalgo, por el de Ley de Acceso de las Mujeres a una Vida Libre de Violencias para el Estado de Hidalgo y se reforman diversas disposiciones de dicho ordenamiento.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_sep_18_alc2_37.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (28/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 714 – LXVI por el que se reforma la fracción III del artículo 7 de la Ley de los Derechos de las Personas Adultas Mayores del Estado de Hidalgo, en materia de cuidados paliativos y atención integral.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_28_alc5_34.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (06/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 728 – LXVI por el que se expiden la Ley de Transparencia y Acceso a la Información Pública para el Estado de Hidalgo; la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados para el Estado de Hidalgo; y se reforman y adicionan diversas disposiciones a la Ley Orgánica de la Administración Pública para el Estado de Hidalgo.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_oct_06_alc0_40.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (06/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto número 729 – LXVI por el que se reforman, adicionan y derogan diversas disposiciones de la Ley Orgánica de la Administración Pública para el Estado de Hidalgo.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_oct_06_alc0_40.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (13/Abril/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto por el que se aprueba el programa Especial Concurrente para el Desarrollo Rural Sustentable 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/13042026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (13/Abril/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto por el que se aprueba el Programa Nacional de Cultura Física y Deporte 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/13042026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto por el que se aprueban diversos programas especiales y uno regional derivados del Plan Nacional de Desarrollo 2025-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (17/Abril/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto por el que se crea el Servicio Universal de Salud del Gobierno de México.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/17042026-VES.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto por el que se reforman, adicionan y derogan diversas disposiciones de la Ley Federal de Procedimiento Contencioso Administrativo.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09062026-VES.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (09/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Decreto por el que se reforman, adicionan y derogan diversas disposiciones del Reglamento del Servicio de Medicina Preventiva en el Transporte.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/09062026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (22/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Expediente 606/20-RA1-01-7. Circular por la que se comunica a las dependencias y entidades de la administración pública federal, a las empresas productivas del estado, así como a las entidades federativas, municipios y alcaldías de la Ciudad de México, que la empresa RMCH CONSTRUCCIONES S.A. DE C.V. y al C. JOSÉ RICARDO MONTIEL CHAVARRÍA fueron inhabilitadas por el periodo de tres meses.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jun_22_ord0_25.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (21/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Lineamientos para la promoción de la inversión en territorio nacional en la producción de medicamentos, insumos para la salud y dispositivos médicos, o en el desarrollo de investigación científica.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/21052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (05/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Modificaciones al Programa Anual de Auditorías para la Fiscalización Superior de la Cuenta Pública 2025.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/05062026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (12/Junio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Norma Oficial Mexicana NOM-005-SSA-2026, De los Servicios de Planificación Familiar y Anticoncepción",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/12062026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (19/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Norma Oficial Mexicana NOM-137-SSA1-2025. Etiquetados de dispositivos médicos.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/19052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (12/Octubre/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Norma Oficial Mexicana NOM-253-SSA1-2025, Para la disposición de sangre humana y sus componentes con fines terapétuicos.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/12102026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (21/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Nota aclaratoria al Acuerdo por el que se emiten los Lineamientos para la obtención del Folio de Registro en el Plan Maestro Nacional de Infraestructura en Salud y Equipamiento Médico de Alta Tecnología.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/21082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa de Cooperación para el Desarrollo 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (13/Abril/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Especial Concurrente para el Desarrollo Rural Sustentable 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/13042026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Especial en materia de Humanidades, Ciencias, Tecnologías e Innovación 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (13/Abril/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional de Cultura Física y Deporte 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/13042026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional de Derechos Humanos 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional de Población 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional de Protección Civil 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional de Protección de Niñas, Niños y Adolescentes 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional de Proyectos Estratégicos para la Igualdad Sustantiva entre Mujeres y Hombres 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional de Remediación de Sitios Contaminados 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional de Seguridad Pública 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional de Trabajo y Empleo para las personas con Discapacidad 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional Forestal 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional Hídrico 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional para la igualdad y No Discriminación 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },    
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Nacional para la Prevención Social de la Violencia y la Delincuencia 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            },
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (18/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Programa Regional General Lázaro Cárdenas del Río 2026-2030.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/18052026-MAT.pdf"
            }
         ]
    }, 
    {
        "tramite_loc" : "Diario Oficial de la Federación (20/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Reglas de organización y funcionamiento de los Comités Interinstitucionales Especializados.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/20072026-MAT.pdf"
            }
         ]
    }, 
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (09/Febrero/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Reporte sobre el Ejercicio, Destino y Resultados de los Recursos Públicos cuarto trimestre 2025.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_feb_09_ord0_06.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (17/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Respuesta a los comentarios recibidos respecto del Proyecto de Norma Oficial Mexicana NOM-253-SSA1-2024, para la disposición de sangre humana y sus componentes con fines terapéuticos, publicado el 8 de noviembre de 2024.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/17082026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Diario Oficial de la Federación (25/Mayo/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Respuestas a los comentarios recibidos respecto del Proyecto de Norma Oficial Mexicana PROY-NOM-005-SSA-2025, De los Servicios de Planificación Familiar y Anticoncepción, publicado el 16 de abril de 2025.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/25052026-MAT.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (10/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Servicios de Salud de Hidalgo. Informe definitivo de 2025 sobre el ejercicio, destino y resultados de los recursos públicos.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_10_ord0_32.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (10/Agosto/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Servicios de Salud de Hidalgo. Reporte del segundo trimestre de 2026 sobre el ejercicio, destino y resultados de los recursos públicos.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_ago_10_ord0_32.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (09/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Tribunal Federal de Justicia Administrativa. Sala auxiliar en materia de responsabilidades administrativas graves.- Expediente 1338/23-RA1-01-5. Circular por la que se comunica a las dependencias y entidades de la administración pública federal, a las empresas productivas del estado, así como a las entidades federativas, municipios y alcaldías de la Ciudad de México que el particular vinculado con falta administrativa grave JUAN RAÚL GARCÍA CALVO, se encuentra en una inhabilitación temporal por el período de tres meses para participar en adquisiciones, arrendamientos, servicios u obras públicas.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_09_alc2_27.pdf"
            }
         ]
    },
    {
        "tramite_loc" : "Periódico Oficial del Estado de Hidalgo (09/Julio/2026)",
         "tramites_array" : [
            {
                "tramite_item_nombre" : "Tribunal Federal de Justicia Administrativa. Sala auxiliar en materia de responsabilidades administrativas graves.- Expediente 1824/24-RA1-01-5. Circular por la que se comunica a las dependencias y entidades de la administración pública federal, a las empresas productivas del estado, así como a las entidades federativas, municipios y alcaldías de la Ciudad de México que la particular responsable NORMA PATRICIA SOLÍS PRADO, se encuentra en una inhabilitación temporal por el período de tres meses para participar en adquisiciones, arrendamientos, servicios u obras públicas.",
                "transparencia_item_url" : "../../../contenido/informacion/publicaciones/DOF/2026_jul_09_alc2_27.pdf"
            }
         ]
    },
]

